<template>
  <div
    class="chat-counter d-flex align-center align-self-center justify-center f13 fw400 white--text rounded-circle px-1"
    v-if="counter > 0"
    :class="{
      squareoval: counter > 99,
      primary: isNotificationsEnabled,
      'secondary darken-1': !isNotificationsEnabled,
    }"
  >
    {{ counter }}
  </div>
</template>

<script>
export default {
  name: 'ChatCounter',
  props: {
    counter: Number,
    isNotificationsEnabled: { type: [Boolean], default: true },
  },
}
</script>

<style lang="scss" scoped>
.chat-counter {
  min-width: 25px;
  height: 25px;
  &.squareoval {
    border-radius: 10px;
    // padding: 0 10px;
  }
}
</style>
